import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';

export enum LoyaltyCardsActionTypes {
  LoadLoyaltyCards = '[LoyaltyCards] LoadLoyaltyCards',
  LoadLoyaltyCardsSuccess = '[LoyaltyCards] LoadLoyaltyCardsSuccess',
  LoadLoyaltyCardsError = '[LoyaltyCards] LoadLoyaltyCardsError',
  AddLoyaltyCards = '[LoyaltyCards] AddLoyaltyCards',
  AddLoyaltyCardsSuccess = '[LoyaltyCards] AddLoyaltyCardsSuccess',
  AddLoyaltyCardsError = '[LoyaltyCards] AddLoyaltyCardsError',
  DeleteLoyaltyCard = '[LoyaltyCards] DeleteLoyaltyCard',
  DeleteLoyaltyCardSuccess = '[LoyaltyCards] DeleteLoyaltyCardSuccess',
  DeleteLoyaltyCardError = '[LoyaltyCards] DeleteLoyaltyCardError',
  getGoogleWalletPass = '[LoyaltyCards] getGoogleWalletPass',
  getGoogleWalletPassSuccess = '[LoyaltyCards] getGoogleWalletPassSuccess',
  getGoogleWalletPassError = '[LoyaltyCards] getGoogleWalletPassError',
  getAppleWalletPass = '[LoyaltyCards] getAppleWalletPass',
  getAppleWalletPassSuccess = '[LoyaltyCards] getAppleWalletPassSuccess',
  getAppleWalletPassError = '[LoyaltyCards] getAppleWalletPassError',
}

export const loadLoyaltyCardsAction = createAction(LoyaltyCardsActionTypes.LoadLoyaltyCards);

export const loadLoyaltyCardsSuccessAction = createAction(LoyaltyCardsActionTypes.LoadLoyaltyCardsSuccess, props<{ loyaltyCards: any }>());

export const loadLoyaltyCardsErrorAction = createAction(
  LoyaltyCardsActionTypes.LoadLoyaltyCardsError,
  props<{ failure: AppStateFailure }>()
);

export const addLoyaltyCardsAction = createAction(LoyaltyCardsActionTypes.AddLoyaltyCards, props<{ loyaltyCardID: number }>());

export const addLoyaltyCardsSuccessAction = createAction(LoyaltyCardsActionTypes.AddLoyaltyCardsSuccess);

export const addLoyaltyCardsErrorAction = createAction(LoyaltyCardsActionTypes.AddLoyaltyCardsError, props<{ failure: AppStateFailure }>());

export const deleteLoyaltyCardAction = createAction(LoyaltyCardsActionTypes.DeleteLoyaltyCard, props<{ loyaltyCardID: number }>());

export const deleteLoyaltyCardSuccessAction = createAction(LoyaltyCardsActionTypes.DeleteLoyaltyCardSuccess);

export const deleteLoyaltyCardErrorAction = createAction(
  LoyaltyCardsActionTypes.DeleteLoyaltyCardError,
  props<{ failure: AppStateFailure }>()
);

export const getGoogleWalletPassAction = createAction(LoyaltyCardsActionTypes.getGoogleWalletPass);

export const getGoogleWalletPassSuccessAction = createAction(
  LoyaltyCardsActionTypes.getGoogleWalletPassSuccess,
  props<{ getGoogleWalletPass: any }>()
);

export const getGoogleWalletPassErrorAction = createAction(
  LoyaltyCardsActionTypes.getGoogleWalletPassError,
  props<{ failure: AppStateFailure }>()
);

export const getAppleWalletPassAction = createAction(LoyaltyCardsActionTypes.getAppleWalletPass);

export const getAppleWalletPassSuccessAction = createAction(
  LoyaltyCardsActionTypes.getAppleWalletPassSuccess,
  props<{ appleWalletPass: any }>()
);

export const getAppleWalletPassErrorAction = createAction(
  LoyaltyCardsActionTypes.getAppleWalletPassError,
  props<{ failure: AppStateFailure }>()
);
